import React, { useRef } from 'react';
import Routes from 'containers/Router';
import './Main.scss';
import ShortMenuBar from 'componentsV2/ShortMenuBar/ShortMenuBar';
import Header from 'componentsV2/Header/Header';

const Main = () => {
  const searchRef = useRef<HTMLCoreSearchElement>(null) as any;
  
  return (
    <div className="main">
      <div className="main-content">
        <Header searchRef={searchRef}/>
        <Routes />
      </div>
      <ShortMenuBar searchRef={searchRef} />
    </div>
  );
};

export default Main;
